
    <div class="modal-header">
      <h4 class="modal-title">Nota Premiada Bahia - Atenção!</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h5>{{mensagem}}</h5>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="onUserConfirm(true)">OK</button>
      <button type="button" class="btn btn-danger" (click)="onUserConfirm(false)">Cancelar</button>
    </div>


// WEBPACK FOOTER //
// ./src/app/shared/modal/nbp-confirm.component.ts.NbpConfirmComponent.html